import { useTranslation } from "react-i18next";
import InputColor from "./InputColor";
import MultiOptionsInput from "./MultiOptionsInput";

const ColorSelectorPress = ({
  pressStorefrontMainColor = "",
  pressStorefrontSecondaryTextColor = "white",
  onChange = () => {},
  onChangeColor = () => {},
}) => {
  const { t } = useTranslation(["dashboard", "common"]);
  return (
    <div className="color-selector">
      <div className="color-container">
        <div className="color-picker-container mt-6">
          <label>{t("branding.storefrontMainColor")}</label>
          <InputColor
            inputName="pressStorefrontMainColor"
            inputNameColor="pressStorefrontMainColorPicker"
            value={pressStorefrontMainColor}
            onChange={onChangeColor}
          />
        </div>
        <div className="color-picker-container mt-6">
          <label>{t("branding.storefrontSecondaryColorText")}</label>
          <MultiOptionsInput
            value={pressStorefrontSecondaryTextColor}
            onChange={onChange}
            options={["white", "black"]}
            optionLabels={{
              white: t("common:colors.white"),
              black: t("common:colors.black"),
            }}
            inputName="pressStorefrontSecondaryTextColor"
          />
        </div>
      </div>
    </div>
  );
};

export default ColorSelectorPress;
